<template>
  <div
    id="fixed-bottom-nav-div"
    class="col-type-02 fixed-bottom-area"
  >
    <div class="save-label">
      応募フォームで編集した内容は途中保存可能です。
    </div>
    <div class="save-balloon-login" />
    <div class="-block w49 save-button">
      <a class="link-button review">
        <img
          class="heart"
          :src="`${userCommonImageUrlForSp}/icon_heart_sp.png`"
        >気になる
      </a>
    </div>
    <div class="-block w49">
      <a
        v-if="isSimple && !isOriginalEntryForm"
        class="link-button -type02 -pr"
        data-test="simple"
      >
        <img :src="`${userOfferImageUrlForSp}/icon_pr.png`">
        シンプル応募
      </a>
      <a
        v-else
        class="link-button -type02"
        data-test="entry"
      >
        応募する
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    isSimple: {
      type: Boolean,
      default: false
    },
    isOriginalEntryForm: {
      type: Boolean,
      default: false
    }
  }
}
</script>
